import { render } from "./BackendMenuComponent.vue?vue&type=template&id=4974fbf6"
import script from "./BackendMenuComponent.vue?vue&type=script&lang=js"
export * from "./BackendMenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/layouts/backend/BackendMenuComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4974fbf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4974fbf6', __exports__)) {
    api.reload('4974fbf6', __exports__)
  }
  
  module.hot.accept("./BackendMenuComponent.vue?vue&type=template&id=4974fbf6", () => {
    api.rerender('4974fbf6', render)
  })

}


export default __exports__